import React from 'react';
import {IconSVG} from "../../../shared/ui/icon/IconSVG";
import colorUtils from "../../../shared/colorUtils";

const EmployeeItem = ({employee, currentViewCalendar}: {
    employee: any,
    currentViewCalendar: "timeGridWeek" | "dayGridMonth" | "timeGridDay"
}) => {

    return (
        <div className={'calendar-user-item'}>
            <div className={'d-flex gap-2 align-items-center'}>
                {(!currentViewCalendar || currentViewCalendar === 'timeGridWeek') &&
                    <div className={'item item-hours'}
                         style={{backgroundColor: employee.color}}>
                        {employee.weeklyContractHours || 0}h
                        / {employee.resultMinutes}h
                    </div>}
                <div className={'fc-drag-item item item-label '} id={employee.idDocument}
                     data-user-id={employee.idDocument}
                     draggable={(!currentViewCalendar || currentViewCalendar === 'timeGridWeek')}
                     style={{backgroundColor: employee.color}}>
                    <div className={'d-flex gap-2 me-auto'}>
                        <IconSVG icon={'assets/icons/user.svg'} size={'12px'} className={'icon-user me-2'}/>
                        {employee.name}
                    </div>
                </div>
                {!employee.isSalvageable &&
                    <IconSVG icon={'assets/icons/warning.svg'} size={'24px'} className={'icon-user me-2'}
                             tintColor={colorUtils.theme.orange}
                             title={"Attenzione, controllare il numero delle ore inserite per l'utente"}/>}
            </div>
        </div>
    );
};

export default EmployeeItem;
